import { ApplianceList } from '../../app/modules/chart/interface/interfaces';
import { ReduxAction, ReduxType } from '../interface';

const data: ApplianceList = {
  appliance: []
};
export default (state: ApplianceList, action: ReduxAction<ApplianceList>) => {
  if (!state) {
    state = data;
  }
  if (action.type === ReduxType.APPLIANCE_LIST) {
    return Object.assign({}, state, action.payload);
  } else {
    return state;
  }
};
